export default __webpack_public_path__ + "static/media/fad-logo-live.3b2f5e0e.svg";